// ChowNow company/hq helpers (not cuboh company/location)
import { MAX_PAGE_SIZE } from 'constants/chownow';
import { CUBOH_COMPANY_PREFIX } from 'constants/path';
import { apiRequest } from './api';

export const fetchCompany = async ({ companyId, setError }) => {
  const { data } = await apiRequest({
    path: `company/${companyId}`,
    apiVersion: '4.0',
    setError,
  });

  return data;
};

export const fetchCompanyLocations = async ({ companyId, setError, excludeHidden = true }) => {
  const basePath = `company/${companyId}/restaurants`;
  const allTheData = [];
  let continueFetching = true;
  let page = 1;

  while (continueFetching) {
    const params = new URLSearchParams({
      exclude_hidden: excludeHidden,
      page,
      page_size: MAX_PAGE_SIZE,
    });

    const {
      data: response,
      // eslint-disable-next-line no-await-in-loop
    } = await apiRequest({
      path: `${basePath}?${params.toString()}`,
      customHost: import.meta.env.VITE_ADMIN_API_HOST,
      setError,
    });

    const { data, pagination } = response || {};
    if (data) {
      allTheData.push(...data);
    }

    if (!pagination || pagination.page >= pagination.total_pages) {
      continueFetching = false;
    } else {
      page += 1;
    }
  }

  return allTheData;
};

const REMOVE_CUBOH_PREFIX_REGEX = new RegExp(`^${CUBOH_COMPANY_PREFIX}`);
export const removeCubohPrefix = str => str.replace(REMOVE_CUBOH_PREFIX_REGEX, '');
